import React, { Component } from "react";
import { connect } from "react-redux";
import { CONST } from '../../../_config';
import DashboardUser from "../Dashboard/DashboardUser";
import Heading from "../Component/UI/ViewButton";
import ViewButton from "../Component/UI/ViewButton";
import TriangleChart from "./Charts/TriangleChart";
import { MdArrowForwardIos } from "react-icons/md";
import moment from "moment";
import { questionsActions } from "../../../_actions";

class SelfDashbaord extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageName: "/assessment/survey"
    };
  }

  componentDidMount() {
    this.props.dispatch(questionsActions.getAssessmentReport());
    this.props.dispatch(questionsActions.getAssessmenrEmployeeDetails({}));
    this.props.dispatch(questionsActions.getSurveyTakenDate({}));
    this.props.dispatch(questionsActions.getAssessmentStatus({}));
  }

  onTakeSurvey = (code) => {
    if (code) {
      window.open(CONST.SURVEY_URL + code, "_blank")
    }
  }

  onAssessmentSummary = (code) => {
    this.props.history.push(`/assessment/summary/` + code);
  }


  onLogout = () => {
    questionsActions.assessmentSurveyLogout(this.props);
    this.props.history.push(`/assessment/surveylogin`);
  }


  selectChatBookMark = () => {
  }

  openAIBot = () => {
    this.props.history.push(`/assessment/mychatbot`);
  }

  switchToAdmin = () => {
    this.props.history.push(`/assessment/overview`);
  };

  render() {

    let { assessment, questions } = this.props;
    let { getEmployeeSurveysData } = assessment;
    let { getAssessmentReportByEmpIDData, getAssessmenrEmployeeDetailsData } = questions;

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    const surveys = Array.isArray(getEmployeeSurveysData)
      ? getEmployeeSurveysData.map((ele = {}) => ({
        title: ele?.surveyId?.name ?? "",
        desc: "This assessment measures your motivations and values, and explain the way we make meaning of life events.",
        date: ele?.createdAt ? moment.unix(ele.createdAt / 1000).format("DD MMMM, YYYY") : "",
        code: ele?.code,
        action: ele?.isComplete
          ? "completed"
          : ele?.isClicked
            ? "continue"
            : "start",
        image: "/img/dashboardhr/employee-survey.svg",
      }))
      : [];

    const assessments =
      Array.isArray(getAssessmentReportByEmpIDData) && getAssessmentReportByEmpIDData.length > 0
        ? getAssessmentReportByEmpIDData
          .slice(0, 5)
          .map((ele, index) => ({
            id: index + 1,
            label: ele?.dimension ?? "",
            color: ele?.colorCode ?? "",
          }))
        : [];



    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: getAssessmenrEmployeeDetailsData?.name ?? "",
      email: getAssessmenrEmployeeDetailsData?.email ?? "",
      period: getPeriod()
    };



    return (
      <DashboardUser userDetails={userDetails} onLogout={this.onLogout}
        pageName={this.state.pageName} switchToAdmin={this.switchToAdmin}
        openAIBot={this.openAIBot} selectChatBookMark={this.selectChatBookMark}>

        {(getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0) &&
          <div className="min-h-screen overflow-hidden overflow-y-auto">

            <div className="mb-10">
              {/* Header */}
              <div className="flex justify-between items-center mb-2">
                <Heading className="text-2xl" title="Executive Snippet" />
                <ViewButton onClick={() => this.onAssessmentSummary(1)} title="View All" Icon={MdArrowForwardIos} />
              </div>

              {/* Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Talent Snapshot */}
                {assessments && assessments.length > 0 && false &&
                  <div className="bg-white border rounded-xl p-6">
                    <Heading className="text-xl" title="Your Talent Snapshot" />
                    <p className="text-sm textlight my-2">Based on your most recent assessment, your top 5 talent themes.</p>
                    <p className="text-xs font-medium italic textblack mb-6">Last assessed: Apr 15, 2024</p>
                    <div className="grid grid-cols-2 gap-6 items-center">
                      <TriangleChart colors={assessments.map((ele) => (ele.color))} />
                      <div className="space-y-2 text-sm">
                        {assessments.map((ele) => (
                          <p key={ele.id} className="flex items-center">
                            <span style={{ borderColor: hexToRgbA(ele.color, "100") }}
                              className="inline-block h-10 border-l-2 px-1">
                            </span>
                            <span className="font-medium textblack">{ele.id + ". " + ele.label}</span>
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>}


              </div>
              {/* Pyramid clip */}
              <style jsx>{`.clip-pyramid {  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);}`}</style>
            </div>

            {/* Your Actions */}
            <div className="mb-10">
              <div className="flex justify-between items-center mb-2">
                <Heading className="text-2xl" title="Your Actions" />
                <ViewButton title="View All" Icon={MdArrowForwardIos} />
              </div>

              <div className="space-y-4">
                {surveys.map((item, index) => (
                  <div key={index} className="flex justify-between items-center bg-white border rounded-lg p-4">
                    <div className="flex items-start gap-4">
                      <div className="w-16 h-16 rounded-lg bglightcolor flex items-center justify-center">
                        <img src={item.image} alt={item.title} className="w-12 h-12 shrink-0" />
                      </div>
                      <div>
                        <h3 className="font-semibold"></h3>
                        <Heading className="text-xl" title={item.title} />
                        <p className="text-sm textblack mt-2 italic">{item.date}</p>
                      </div>
                    </div>

                    {item.action === "start" && (
                      <button onClick={() => this.onTakeSurvey(item.code)} className="bgcolor text-white px-6 py-2 rounded-md">
                        Let's Start
                      </button>
                    )}
                    {item.action === "continue" && (
                      <button onClick={() => this.onTakeSurvey(item.code)} className="border border-[#09529b] textcolor px-6 py-2 rounded-md">
                        Continue
                      </button>
                    )}
                    {item.action === "completed" && (
                      <span className="bg-teal-50 textcolor px-6 py-2 rounded-md text-sm">
                        Completed
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Assessment Section */}
            {getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0 &&
              <div className="mb-10">
                <div className="flex justify-between items-center mb-2">
                  <Heading className="text-2xl" title="Talent Insight" />
                </div>
                <div className="grid grid-cols-3 gap-6">
                  {/* Summary Card */}
                  <div className="bg-white border rounded-lg p-6">
                    <ul className="space-y-2 mb-4">
                      {assessments.map((ele) => (
                        <li key={ele.id} className="flex items-center gap-3 px-3 py-3 rounded" style={{ background: hexToRgbA(ele.color, "0.20") }}>
                          <span style={{ background: hexToRgbA(ele.color, "0.70") }} className="w-6 h-6 rounded-full text-white text-xs flex items-center justify-center font-bold">{ele.id}</span>
                          <span className="text-sm font-medium">{ele.label}</span>
                        </li>
                      ))}
                    </ul>
                    <Heading className="text-xl" title="Summary" />
                    <p className="text-sm textlight my-3">Your Dominant themes are the core qualities that define who you are and contribute to your success.</p>
                    <button onClick={() => this.onAssessmentSummary(1)} className="border border-[#09529b] textcolor px-4 py-2 rounded-md">
                      View Summary
                    </button>
                  </div>

                  {/* Report Card */}
                  <div className="bg-white border rounded-lg p-6">
                    <img src="/img/dashboardhr/report.png" alt="report" className="rounded-md mb-4 w-full" />
                    <Heading className="text-xl" title="Report" />
                    <p className="text-sm textlight my-3"> Your Dominant themes are the core qualities that define who you are and contribute to your success.</p>
                    <button onClick={() => this.onAssessmentSummary(2)} className="border border-[#09529b] textcolor px-4 py-2 rounded-md">View Report</button>
                  </div>

                  {/* Video Card */}
                  <div className="bg-white border rounded-lg p-6">
                    <div className="relative mb-4">
                      <img src="/img/dashboardhr/video.png" alt="video" className="rounded-md w-full" />
                      <span className="absolute inset-0 flex items-center justify-center text-white text-3xl">
                        ▶
                      </span>
                    </div>
                    <Heading className="text-xl" title="Assessment Video" />
                    <p className="text-sm textlight my-3"> Your Dominant themes are the core qualities that define who you are and contribute to your success.</p>
                    <button onClick={() => this.onAssessmentSummary(3)} className="border border-[#09529b] textcolor px-4 py-2 rounded-md">Watch Video</button>
                  </div>
                </div>
              </div>}

          </div>
        }

      </DashboardUser>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment
  };
}

export default connect(mapStateToProps)(SelfDashbaord);

